<template>
  <div>
    <ContentLoader
      :height="40"
      :width="320"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="text-loader-mobile"
    >
      <rect x="0" y="2" rx="4" ry="4" width="310" height="16" />
      <rect x="0" y="24" rx="4" ry="4" width="290" height="16" />
    </ContentLoader>

    <ContentLoader
      :height="28"
      :width="720"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="text-loader-tablet"
    >
      <rect x="0" y="2" rx="4" ry="4" width="700" height="22" />
    </ContentLoader>

    <ContentLoader
      :height="56"
      :width="600"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="text-loader-desk"
    >
      <rect x="0" y="2" rx="4" ry="4" width="570" height="22" />
      <rect x="0" y="32" rx="4" ry="4" width="200" height="22" />
    </ContentLoader>
  </div>
</template>

<style lang="scss" scoped>

.text-loader-mobile {
  max-width: 320px;

  @media (min-width: $screen-sm-min) {
    display: none;
  }
}

.text-loader-tablet {
  display: none;

  @media (min-width: $screen-sm-min) {
    display: block;
    max-width: 720px;
  }

  @media (min-width: $screen-md-min) {
    display: none;
  }
}

.text-loader-desk {
  display: none;

  @media (min-width: $screen-md-min) {
    display: block;
    max-width: 600px;
  }
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>
